import { UIManager, LayoutAnimation } from 'react-native';

import moment from 'moment';

import { ADD_ON_DETAILS_MODES } from './AddOnDetails.Enum';

const getDateLabel = (modeType, autoRenew) => {
  switch (modeType) {
    case ADD_ON_DETAILS_MODES.REMOVE:
    case ADD_ON_DETAILS_MODES.BUY:
      return autoRenew
        ? 'soho_addons_remove_addon_renewal_date_label'
        : 'soho_addons_buy_addons_expiration_date_label';
    case ADD_ON_DETAILS_MODES.REQUEST:
    case ADD_ON_DETAILS_MODES.CANCEL_REQUEST:
      return 'soho_addons_request_addon_duration_label';
  }
};

const getDate = (modeType, validFor, duration) => {
  switch (modeType) {
    case ADD_ON_DETAILS_MODES.REMOVE:
      return validFor?.endDate;
    case ADD_ON_DETAILS_MODES.BUY:
      return moment().add(duration?.amount, duration?.unit).format('DD/MM/yyyy');
    case ADD_ON_DETAILS_MODES.REQUEST:
      return duration?.amount + ' ' + duration?.unit;
    case ADD_ON_DETAILS_MODES.CANCEL_REQUEST:
      return `${duration?.amount} ${duration?.units}`;
  }
};

const getTotalCost = (userCount, price, isCurrencyFirst) => {
  const totalCost = (parseFloat(price?.value) * userCount).toFixed(2);
  const totalCostAndCurrency = isCurrencyFirst
    ? `${price?.currency}${totalCost}`
    : `${totalCost}${price?.currency}`;
  return totalCostAndCurrency;
};

const CustomLayoutAnimation = {
  duration: 150,
  create: {
    type: LayoutAnimation.Types.linear,
    property: LayoutAnimation.Properties.opacity,
  },
  update: {
    type: LayoutAnimation.Types.easeInEaseOut,
  },
};

const onShowMoreToggle = () => {
  UIManager.setLayoutAnimationEnabledExperimental &&
    UIManager.setLayoutAnimationEnabledExperimental(true);
  LayoutAnimation.configureNext(CustomLayoutAnimation);
};

export { getDateLabel, getDate, getTotalCost, onShowMoreToggle };
